import {Alert, View} from 'react-native';
import React, {useState} from 'react';
//////////////////////////
///////  components
import {TopTab, TopTabButton} from 'src/Modules/TabViews';

import AboutExplorerPass from 'src/ExplorerPass/AboutExplorerPass';
import CallSupportLine from 'src/HeaderComponents/CallSupportLine';
import YourRewardsView from './YourExplorerPassView';
import {apiUpdateUserBadges} from 'src/Utils/apiCalls';

import {useSelector} from 'react-redux';
import {useExplorerPass} from '../Utils/explorerPassHelper';
import {useUserId} from '../Hooks/reduxHooks';

const ExplorerPassMapLanding = () => {
  const playTestState = useSelector((state) => state.app_info?.playTestState);
  const userId = useUserId();

  const [view, setView] = useState('about');

  const _onRefresh = async () => {
    if (!!userId) {
      apiUpdateUserBadges(userId).then(() => {});
    } else {
      Alert.alert('You must be logged in to see your past hunts');
    }
  };

  const pass = useExplorerPass();
  let hasValidExplorerPass = !!pass;

  // Alert.alert(hasValidExplorerPass ? 'Valid Pass' : 'Invalid Pass');

  return (
    <View style={{flex: 1, position: 'relative'}}>
      <CallSupportLine />
      <TopTab>
        {!playTestState && !hasValidExplorerPass && (
          <TopTabButton
            text={'What Is It?'}
            active={view === 'about'}
            handlePress={() => setView('about')}
          />
        )}
        {!playTestState && hasValidExplorerPass && (
          <TopTabButton
            text={`Your Pass`}
            active={view === 'about'}
            handlePress={() => setView('about')}
          />
        )}
      </TopTab>
      <View
        style={{
          flex: 1,
          position: 'relative',
          backgroundColor: global?.color?.white1,
        }}>
        {view === 'about' && !!hasValidExplorerPass && (
          <YourRewardsView
            onRefresh={_onRefresh}
            pass={pass}
            showAllLocations={() => {
              // setActiveSearch(true)
              try {
                //
              } catch (error) {
                console.log('could not set tag');
              }
            }}
            showAllFeaturedLocations={() => {
              // setActiveSearch(true)
              try {
                //
              } catch (error) {
                console.log('could not set tag');
              }
            }}
            city={{name: 'Denver'}}
            // setActiveSearch={(nextState) =>
            //   setActiveSearch(nextState)
            // }
          />
        )}

        {view === 'about' && !hasValidExplorerPass && (
          <AboutExplorerPass handleNavPress={() => setView('list')} />
        )}
      </View>
    </View>
  );
};

// eslint-disable-next-line
export default ExplorerPassMapLanding;
